export function isMicrocredentialHomework(type) {
   return String(type || '').toLowerCase() === 'microcredential';
}

export function getMicrocredentialCourseId(course) {
   return course?.course_id ?? course?.Course_id ?? null;
}

export function getMicrocredentialCourseName(course) {
   return course?.name ?? course?.Name ?? course?.title ?? '';
}

export function getMicrocredentialSubjectIdValue(courseId) {
   const parsedValue = Number(courseId);

   return Number.isInteger(parsedValue) ? parsedValue : 0;
}

export function getMicrocredentialTopicId(topic) {
   return topic?.topic_id ?? topic?.Topic_id ?? null;
}

export function getMicrocredentialTopicName(topic) {
   return topic?.title ?? topic?.Title ?? topic?.name ?? '';
}

export function buildMicrocredentialSubjectCode({
   courseId,
   courseName,
   topicId,
   topicTitle,
}) {
   return JSON.stringify({
      course_id: courseId ?? null,
      course_name: courseName ?? '',
      topic_id: topicId ?? null,
      topic_title: topicTitle ?? '',
   });
}

export function parseMicrocredentialSubjectCode(rawValue) {
   if (!rawValue) return null;

   if (typeof rawValue === 'object') {
      return {
         course_id: rawValue.course_id ?? rawValue.courseId ?? null,
         course_name: rawValue.course_name ?? rawValue.courseName ?? '',
         topic_id: rawValue.topic_id ?? rawValue.topicId ?? null,
         topic_title: rawValue.topic_title ?? rawValue.topicTitle ?? '',
      };
   }

   try {
      const parsed = JSON.parse(rawValue);
      return parseMicrocredentialSubjectCode(parsed);
   } catch (error) {
      return null;
   }
}

export function getMicrocredentialSubjectDisplay(record, { fallbackCourseName = '', topicsById = null } = {}) {
   const metadata = parseMicrocredentialSubjectCode(record?.subject_code);
   const courseName = metadata?.course_name || fallbackCourseName || record?.subject || '';
   const topicId = metadata?.topic_id ?? null;
   const topicTitle = metadata?.topic_title || (topicId && topicsById instanceof Map ? topicsById.get(String(topicId)) : '') || '';

   if (courseName && topicTitle) {
      return `${courseName} - ${topicTitle}`;
   }

   return courseName || topicTitle || record?.subject || '';
}

export function recordMatchesMicrocredentialCourse(record, courseId) {
   if (!record || courseId === null || courseId === undefined || courseId === '') return true;

   const metadata = parseMicrocredentialSubjectCode(record?.subject_code);
   const recordCourseId = metadata?.course_id ?? record?.subject_id ?? null;

   return String(recordCourseId) === String(courseId);
}

export function decorateMicrocredentialRecord(record, options = {}) {
   if (!record) return record;

   return {
      ...record,
      subject: getMicrocredentialSubjectDisplay(record, options),
   };
}

